import { render, staticRenderFns } from "./UIgame.vue?vue&type=template&id=8ff71b4a&scoped=true&"
import script from "./UIgame.vue?vue&type=script&lang=js&"
export * from "./UIgame.vue?vue&type=script&lang=js&"
import style0 from "./UIgame.vue?vue&type=style&index=0&id=8ff71b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff71b4a",
  null
  
)

export default component.exports